/**
 * Formats enum keys for display by replacing underscores with spaces
 * and converting to Title Case.
 * Example: RIGHT_ARM_FAST -> Right Arm Fast
 * @param label The enum key to format
 * @returns The human-readable label
 */
export const formatEnumLabel = (label: string): string => {
  if (label === 'NA') return 'N/A';
  
  return label
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
